import { render } from "./CreateParticipantDialog.vue?vue&type=template&id=4d65472f&ts=true"
import script from "./CreateParticipantDialog.vue?vue&type=script&lang=ts"
export * from "./CreateParticipantDialog.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__